import "@/components/keyword_tags.scss";

import { DestroyableTag } from "@sprout/tag";

const KeywordTags = ({
  keywords,
  onClick,
}: {
  keywords: string[];
  onClick: (keyword: string) => void;
}) => {
  return (
    <div className="keyword-tags">
      {keywords.map((keyword) => (
        <DestroyableTag
          key={keyword}
          label={`"${keyword}"`}
          className="tag-item"
          size="md"
          onClick={() => onClick(keyword)}
        />
      ))}
    </div>
  );
};

export default KeywordTags;
